export default __webpack_public_path__ + "static/media/stkRev.36e81913.png";